import React from 'react';
import { FixResponse } from '../../types/fix';
import { diffStat } from './lanes';

export interface DiffStatBadgeProps {
  fix: FixResponse;
  /** Font size in px, so a card and a table row can each set their own. */
  size?: number;
}

/**
 * How much code a fix touches: `+42 −11`, in the diff colours used everywhere else.
 * Renders nothing until the agent has produced a patch.
 *
 * The minus is U+2212, not a hyphen — it lines up with the plus at the same weight.
 */
const DiffStatBadge: React.FC<DiffStatBadgeProps> = ({ fix, size = 11.5 }) => {
  const stat = diffStat(fix);
  if (!stat) return null;

  return (
    <span
      style={{ display: 'inline-flex', gap: 5, fontSize: size, fontFamily: 'var(--font-mono)' }}
      aria-label={`${stat.added} lines added, ${stat.removed} lines removed`}
    >
      <span style={{ color: 'var(--diff-add)', fontWeight: 600 }}>+{stat.added}</span>
      <span style={{ color: 'var(--diff-del)', fontWeight: 600 }}>−{stat.removed}</span>
    </span>
  );
};

export default DiffStatBadge;
